import { useState } from 'react';
import styles from './Sidebar.module.css';
import Checkbox from '../../compoenets/Checkbox';
import TaskAdd from './TaskAdd';
import ListSkeleton from '../../compoenets/ListSkeleton/ListSkeleton';

const CopyBtn=({item})=>{
    const [isCopy,setIsCopy]=useState();
    const handleCopy=(e,id)=>{
        e.preventDefault();
        e.stopPropagation();
        navigator.clipboard.writeText(id)
        .then(()=>{
            setIsCopy(true)
            setTimeout(() => {
                setIsCopy(false);
            }, 1500);
        })
        .catch(err=>console.error('copy fail:',err))
    }

    return(
        <button 
        onClick={(e)=>handleCopy(e,item.taskId)} 
        className={`${styles['btn-copy']} ${isCopy&&styles['btn-copy-done']}`}
        />
    )

}

export default function Sidebar({
    isLoad,
    className,
    taskList,
    checkedTasks,
    setCheckedTasks,
    onChange,
    dashboardData,
    testsetList,
}){
    const [isTaskAdd,setIsTaskAdd]=useState(false);
    const isAllChecked=checkedTasks.length===taskList.length;

    const stateConvert=(item)=>{

        const taskData=dashboardData.find(obj=>obj.batchId===item.batchId)
        if(!taskData)return;
        if(taskData.state==='COMPLETED')
        return 'COMPLETED'

        if(taskData.maxRound!==taskData.testList?.length)
        return 'Running'

        return 'Pending'
    }

    const handleCheckChange=(itemId)=>{
        setCheckedTasks(prev=>
            prev.includes(itemId)?
            prev.filter(id=>id!==itemId)
            :[...prev,itemId]
        )
    }

    const handleCheckAll=()=>{
        if(checkedTasks.length===taskList.length){
            setCheckedTasks([]);
        }else if(checkedTasks.length!==0){
            setCheckedTasks([]);
        }
        else{
            setCheckedTasks(taskList.map(item=>item.batchId));
        }
    }

    return(
        <nav className={`${className} ${styles['wrap']}`}>
            <section>
                <header>
                    <span>Task List</span>
                    <button onClick={handleCheckAll}>{isAllChecked?'Uncheck All':'Check All'}</button>
                </header>
                <div className={styles['list-body']}>
                    <button onClick={()=>setIsTaskAdd(true)}>Add Task</button>
                    {!isLoad?
                    taskList.map((item)=>
                        <div className={styles['item']} onClick={()=>handleCheckChange(item['batchId'])}>
                            {
                            dashboardData.find(obj=>obj.batchId===item.batchId)?.state!=='Pending'?
                            <Checkbox 
                            isChecked={checkedTasks.includes(item['batchId'])}
                            onChange={()=>handleCheckChange(item['batchId'])}
                            color={dashboardData.find(obj=>obj.batchId===item.batchId)?.color}
                            />
                            :
                            <span className={`${styles['label-pending']} ${checkedTasks.includes(item['batchId'])&&styles['label-pending-on']}`}/>
                            }
                            <div className={styles['item-title']}>
                                <span>{item['taskName']}</span>
                                <span>{"ID: "+item.taskId.split('-')[0]} {"Round: "+item.maxRound}</span>
                            </div>
                            <CopyBtn item={item}/>
                            
                        </div>
                    )
                    :
                    <>
                        <ListSkeleton/>
                        <ListSkeleton/>
                        <ListSkeleton/>
                        <ListSkeleton/>
                        <ListSkeleton/>
                        <ListSkeleton/>
                        <ListSkeleton/>
                        <ListSkeleton/>
                    </>
                    }
                </div>
            </section>
            {isTaskAdd&&<TaskAdd 
            testsetList={testsetList}
            onChange={onChange}
            onClose={()=>setIsTaskAdd(false)}

            />}
        </nav>
    )
}